import { Star } from "lucide-react";

/** Gwiazdki oceny — jeden wygląd dla karty firmy i dla zamówienia. */

export function Stars({ value, size = 13 }: { value: number; size?: number }) {
  return (
    <span className="inline-flex items-center gap-0.5" title={value.toFixed(2)}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          className={
            n <= Math.round(value)
              ? "fill-amber-400 text-amber-400"
              : "text-[var(--color-border)]"
          }
        />
      ))}
    </span>
  );
}

export function StarPicker({
  value,
  onChange,
}: {
  value: number;
  onChange: (v: number) => void;
}) {
  return (
    <span className="inline-flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n)}
          aria-label={`${n} z 5`}
          className="p-0.5"
        >
          <Star
            size={20}
            className={
              n <= value ? "fill-amber-400 text-amber-400" : "text-[var(--color-border)]"
            }
          />
        </button>
      ))}
    </span>
  );
}
